module.exports = __webpack_public_path__ + "static/media/creditcardbenefits-5.79f73a38.svg";